import { Component, ElementRef, input, output, QueryList, ViewChild, ViewChildren } from '@angular/core';

interface AssignedInstitution {
  id: string;
  name: string;
}

@Component({
  selector: 'app-institution-transfer-list',
  templateUrl: './institution-transfer-list.html',
})
export class InstitutionTransferList {
  availableInstitutions = input.required<string[]>();
  assignedInstitutions = input.required<AssignedInstitution[]>();
  selectedAvailable = input.required<string[]>();
  selectedAssigned = input.required<string[]>();
  isEditable = input<boolean>(false);
  idPrefix = input<string>('institution-transfer');

  availableSelectedToggle = output<string>();
  assignedSelectedToggle = output<string>();
  moveToAssignedClick = output<void>();
  moveAllToAssignedClick = output<void>();
  moveAllToAvailableClick = output<void>();
  moveToAvailableClick = output<void>();
  availableKeydown = output<KeyboardEvent>();
  assignedKeydown = output<KeyboardEvent>();
  availableListBlur = output<void>();
  assignedListBlur = output<void>();

  @ViewChild('availableList') private availableListRef!: ElementRef<HTMLElement>;
  @ViewChild('assignedList') private assignedListRef!: ElementRef<HTMLElement>;
  @ViewChildren('availableItem') availableItems!: QueryList<ElementRef<HTMLDivElement>>;

  scrollToTop(): void {
    if (this.availableListRef) this.availableListRef.nativeElement.scrollTop = 0;
    if (this.assignedListRef) this.assignedListRef.nativeElement.scrollTop = 0;
  }

  focusListContainer(event: Event): void {
    const container = event.currentTarget as HTMLElement | null;
    container?.focus();
  }

  onAvailableListFocusOut(event: FocusEvent): void {
    if (this.isFocusLeavingTransferWidget(event)) {
      this.availableListBlur.emit();
    }
  }

  onAssignedListFocusOut(event: FocusEvent): void {
    if (this.isFocusLeavingTransferWidget(event)) {
      this.assignedListBlur.emit();
    }
  }

  private isFocusLeavingTransferWidget(event: FocusEvent): boolean {
    const nextFocused = event.relatedTarget as HTMLElement | null;
    const current = event.currentTarget as HTMLElement | null;
    const widgetRoot = current?.closest('.institution-transfer-root');

    if (!widgetRoot) {
      return true;
    }

    return !nextFocused || !widgetRoot.contains(nextFocused);
  }
}
